export default import.meta.ROLLUP_FILE_URL_WFHrEU78LbAH0OIV$gG5mg;